import HomeSection from '@efdigital/ll-admin-v2/components/client-edit/home-section.gts';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditRecord } from '@efdigital/ll-admin-v2/components/edit-record.gts';
import type { LibraryClientsEditHomeModel } from '@efdigital/ll-admin-v2/routes/library/clients/client/edit/home';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    model: LibraryClientsEditHomeModel;
  };
}

const ClientHomeRoute: TemplateOnlyComponent<Signature> = <template>
  {{#if @model.home}}
    <EditContext as |context|>
      <EditRecord
        @editLabel="Edit Leadership Live Settings"
        @item={{@model.home}}
        @context={{context}}
        @buttonSize="btn-md"
        @maxDepth={{1}}
      >
        <:form as |uniqueId isReadOnly|>
          <HomeSection
            @home={{@model.home}}
            @uniqueId={{uniqueId}}
            @isReadOnly={{isReadOnly}}
          />
        </:form>
      </EditRecord>
    </EditContext>
  {{else}}
    <div class="alert alert-warning" role="status">
      <iconify-icon inline icon="ph:warning" aria-hidden="true" />
      Unable to load Leadership Live settings. Please reload the page.
    </div>
  {{/if}}
</template>;

export default ClientHomeRoute;
